import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";

export default function MantraLekhanSignIn() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [keepSignedIn, setKeepSignedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    setIsLoading(true);
    // Add your login logic here
    setTimeout(() => {
      setIsLoading(false);
      // Redirect to dashboard after successful login
      navigate("/mantra-lekhan-dashboard");
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Side - Illustration */}
          <div className="hidden md:flex justify-center">
            <img
              src="./assets/mantra lekhan.webp"
              alt="Mantra Lekhan"
              className="w-full rounded-lg shadow-lg"
            />
          </div>

          {/* Right Side - Form */}
          <div className="w-full max-w-md mx-auto">
            {/* Header */}
            <div className="text-center mb-8">
              <div className="flex items-center justify-center gap-2 mb-4">
                <span className="text-4xl">🙏</span>
                <h1 className="text-4xl font-bold">
                  Welcome To <span className="text-red-600">Mantra Lekhan</span>
                </h1>
              </div>
              <p className="text-gray-600 text-sm mb-2">
                Total{" "}
                <span className="font-semibold text-red-600">329,456,036</span>{" "}
                Mantralekhan By{" "}
                <span className="font-semibold text-red-600">15,566</span>{" "}
                Registered Users On This Site And Counting...
              </p>
              <p className="text-gray-600 text-sm">
                This is An Endeavor To Please Bhagwan Swaminarayan By Typing{" "}
                <span className="italic font-semibold">"Swaminarayan"</span>{" "}
                Mahamantra Online.
              </p>
            </div>

            {/* Form */}
            <form onSubmit={handleLogin} className="space-y-6">
              {/* Username Field */}
              <div>
                <label className="block text-gray-700 font-semibold mb-2">
                  Username
                </label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter your user ID"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent transition"
                />
              </div>

              {/* Password Field */}
              <div>
                <label className="block text-gray-700 font-semibold mb-2">
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent transition"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-4 top-3.5 text-gray-600 hover:text-gray-800 transition"
                  >
                    {showPassword ? (
                      <FiEyeOff className="w-5 h-5" />
                    ) : (
                      <FiEye className="w-5 h-5" />
                    )}
                  </button>
                </div>
              </div>

              {/* Remember Me & Forgot Password */}
              <div className="flex items-center justify-between">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={keepSignedIn}
                    onChange={(e) => setKeepSignedIn(e.target.checked)}
                    className="w-4 h-4 border border-gray-300 rounded cursor-pointer"
                  />
                  <span className="text-gray-600 text-sm">
                    Keep me signed in
                  </span>
                </label>
                <Link
                  to="/forgot-password"
                  className="text-red-600 hover:text-red-700 font-semibold text-sm transition"
                >
                  Forgot password?
                </Link>
              </div>

              {/* Login Button */}
              <button
                type="submit"
                disabled={isLoading}
                className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-4 rounded-full transition duration-200 disabled:opacity-75 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                {isLoading ? (
                  <>
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    Logging in...
                  </>
                ) : (
                  "Login"
                )}
              </button>

              {/* Refresh Button */}
              <button
                type="button"
                className="w-full border-2 border-gray-300 hover:border-red-600 text-gray-700 font-semibold py-2.5 px-4 rounded-full transition flex items-center justify-center gap-2"
              >
                <span>🔄</span>
              </button>
            </form>

            {/* Sign Up Link */}
            <div className="text-center mt-6">
              <p className="text-gray-600 text-sm">
                You are a new member?{" "}
                <Link
                  to="/sign-up"
                  className="text-red-600 hover:text-red-700 font-semibold transition"
                >
                  Sign Up
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
